<template>
  <div>
    <div class="col-12">
      <div>
        <b-button
          class="section-offer w-100 mb-4"
          v-b-toggle.savedCard
          variant="transparent"
        >Saved Card</b-button>

        <b-collapse id="savedCard">
          <div>
            <div
              v-if="savedCreditCards.length > 0"
              v-for="(card,cardKey) in savedCreditCards"
              :key="cardKey"
              class="saved-card"
              :class="selectedCard.cardID == card.cardID ? 'card-selected':''"
            >
              <div v-on:click="onselectcard(card)">
                <div class="h6">{{card.cardBankName}}</div>
                <div>{{ card.cardNumbers }}</div>
              </div>
              <div class="d-flex align-items-center">
                <label class="mr-3 mb-0 small" for="cvv">CVV</label>
                <input
                  v-model="card.CVV"
                  v-on:keydown="CCOnKeyUp(1,'cvv', $event,card)"
                  placeholder="123"
                  type="number"
                  class="form-control"
                  id="cvv"
                />
                <img
                  v-on:click="onRemoveCard(card)"
                  src="@/assets/img/icons8-trash-50.png"
                  class="pl-2 cursor-pointer"
                  width="34px"
                  height="24px"
                  alt
                />
              </div>
            </div>
            <button
              v-if="savedCreditCards.length > 0"
              @click="onClickExpressPay()"
              class="btn-confirm active mb-3"
            >Proceed</button>

            <div v-if="savedCreditCards.length == 0" class="text-muted mt-5">
              You do not have any saved
              Credit/Debit card
            </div>
          </div>
        </b-collapse>
      </div>
      <div v-if="paymentBlock">
        <b-button
          class="section-offer w-100"
          v-b-toggle.creaditCard
          variant="transparent"
        >Credit Card</b-button>

        <b-collapse id="creaditCard">
          <div>
            <div class="card">
              <img src="@/assets/img/svg/icon-card.svg" height="30px" width="30px" alt="icon-card" />
              <div id="mount-id"></div>
            </div>

            <div>
              <input id="saveThisCard" v-model="savecardradio" type="checkbox" />
              <label for="saveThisCard">Save this card for future use</label>
            </div>
            <button @click="PayViaNgenius()" type="submit" class="btn-confirm active">Proceed</button>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="payment-frame">
      <div id="3ds_iframe"></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { secureStore } from "@/helper/storage";
import { EventBus } from "@/main";
import VueFriendlyIframe from "vue-friendly-iframe";
import { TokenService, CountryService } from "@/services/storage.service";
import { _, groupBy } from "lodash";
import { URL_BASE } from "@/helper/constant";
import $ from "jquery";
import { PROJECT, metaInfo } from "@/helper/constant.js";

Vue.component("vue-friendly-iframe", VueFriendlyIframe);

export default {
  name: "mobilePayment",
  metaInfo: metaInfo,
  head: {
    title() {
      return `Ticketak`;
    },
    meta: [
      {
        name: "description",
        content() {
          return `Here is the description`;
        }
      }
    ]
  },
  data() {
    return {
      reserveID: "",
      email: "",
      BASEURL: URL_BASE,
      project: PROJECT,
      paymentBlock: true,
      firstCollapsed: true,
      secondCollapsed: true,
      savecardradio: false,
      creditCardDetails: {
        number: ["", "", "", ""],
        expiryMonth: "",
        expiryYear: "",
        name: "",
        cvv: "",
        saveCard: true,
        error: ""
      },
      savedCreditCardDetails: {
        error: ""
      },
      isUserLoggedIn: false,
      verifyError: "",
      savedCreditCards: [],
      cardError: "",
      selectedCard: {},
      walletInfo: {}
    };
  },
  beforeMount() {
    document.addEventListener(
      "DOMContentLoaded",
      function() {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        var ngeniusScript = document.createElement("script");
        script.src =
          "https://paypage-uat.ngenius-payments.com/hosted-sessions/sdk.js";
        ngeniusScript.src =
          "https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js";
        head.appendChild(ngeniusScript);
        //head.appendChild(script);
      },
      false
    );
  },
  mounted: function() {
    this.reserveID = this.$route.query.ReserveID;
    this.email = this.$route.query.email;
    this.createNgeniusCardSection();
    if (this.email != "") {
      this.getSavedCards();
    }
  },
  methods: {
    createNgeniusCardSection() {
      /* Method call to mount the card input on your website */
      window.NI.mountCardInput("mount-id" /* the mount id*/, {
        style: {
          main: {
            margin: "0px",
            padding: "0px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          base: {
            fontSize: "16px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          input: {
            borderWidth: "1px",
            borderRadius: "5px",
            borderStyle: "solid",
            backgroundColor: "#FFFFFF",
            borderColor: "#DDDDDD",
            color: "#000000",
            padding: "5px",
            fontUrl:
              "https://fonts.googleapis.com/css?family=Odibee+Sans&display=swap",
            fontFamily: "Odibee Sans !important"
          },
          invalid: {
            borderColor: "red"
          }
        }, // Style configuration you can pass to customize the UI
        /*apiKey : 'ZDJkOGJlY2EtYzBiZS00MTQ1LWFiZjYtYzg1MjVlODUxMGI3OjM2NDgyZWRmLTM1NmEtNGRlYy04YjcwLWE4ZTUzMTA5NzljMg==', // API Key for WEB SDK from the portal
                 outletRef : '5edab6d7-5946-43f4-b8c7-06b29c272bdd', // outlet reference from the portal
                 */

        apiKey:
          "YWJjMjQyZDEtZWJlMC00NDc1LTlkMmItMWY3Y2ZmYWY0MGFkOjFmMmRlNWY2LTM1NTYtNDU3Yi05ZDVhLTExMGQ4MTU5M2ViNg==", // API Key for WEB SDK from the portal
        outletRef: "e209b88c-9fb6-4be8-ab4b-e4b977ad0e0d", // outlet reference from the portal

        onSuccess: "", // Success callback if apiKey validation succeeds
        onFail: "", // Fail callback if apiKey validation fails
        onChangeValidStatus: ({
          isCVVValid,
          isExpiryValid,
          isNameValid,
          isPanValid
        }) => {
          console.log(isCVVValid, isExpiryValid, isNameValid, isPanValid);
        }
      });
    },
    getSavedCards: function() {
      //let token = this.$persistStore.get("accessToken");
      let token = "";
      let payload = {
        email: this.email
      };
      console.log("payload :", payload);
      makeRequest("/GetSavedCards", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            if (res.data.Cards.length > 0) {
              this.savedCreditCards = res.data.Cards;
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    PayViaNgenius() {
      let self = this;
      self.showLoading();
      var sessionId;
      window.NI.generateSessionId().then(function(response) {
        sessionId = response.session_id;
        console.log(sessionId);
        if (typeof response.session_id !== "undefined") {
          let payload = {
            ReserveID: self.reserveID,
            sid: sessionId,
            saveCard: self.savecardradio ? 1 : 0
          };
          makeRequest("/NProcessPayment", "POST", null, payload)
            .then(response => {
              console.log("result :", response);
              const { res } = response;
              // console.log('Data :', Data);
              if (res.data.Status) {
                document.getElementById("3ds_iframe").innerHTML = res.data.Data;
                self.paymentBlock = false;
                self.check3ds(res.data.Data);
                self.hideLoading();
              } else {
                self.$toasted.show(res.data.Message, {
                  position: "top-center",
                  duration: 5000
                });
              }
            })
            .catch(error => {
              self.$toasted.show(error, {
                position: "top-center",
                duration: 5000
              });
            });
          // $.ajax({
          //     url: "http://192.168.1.155/pay.php",
          //     type: "post",
          //     dataType: 'json',
          //     data: {
          //         sid: sessionId
          //     },
          //     success: function (result) {
          //       console.log('result :', result);
          //         document.getElementById("3ds_iframe").innerHTML = result;
          //         self.check3ds(result);
          //     },
          //     error: function (error) {
          //         console.log(error);
          //         self.$toasted.show(error, {
          //             position: "top-center",
          //             duration : 5000
          //     });
          //     }
          // });
        } else {
          self.$toasted.show(
            "Session cannot be generated, Please try again later",
            {
              position: "top-center",
              duration: 5000
            }
          );
        }
      });
    },
    check3ds(paymentResponse) {
      let self = this;
      if (typeof paymentResponse.orderReference !== "undefined") {
        window.NI.handlePaymentResponse(paymentResponse, {
          mountId: "3ds_iframe"
        }).then(function(response) {
          var status = response.status;

          console.log(status);
          console.log(paymentResponse.orderReference);
          if (
            status == "AUTHORISED" &&
            paymentResponse &&
            paymentResponse.orderReference &&
            paymentResponse.orderReference.length > 0
          ) {
            self.makeTransactions(paymentResponse);
          } else {
            self.$toasted.show(status, {
              position: "top-center",
              duration: 5000
            });
          }
        });
      } else {
        self.$toasted.show("Unable to process payment", {
          position: "top-center",
          duration: 5000
        });
        //document.getElementById("error").style.display = "block";
        //document.getElementById("error").innerHTML = paymentResponse.error;
      }
    },
    makeTransactions(paymentResponse) {
      let self = this;
      let payload = {
        ReserveID: self.reserveID,
        orderReference: paymentResponse.orderReference
      };
      makeRequest("/ProcessTicket", "POST", null, payload)
        .then(response => {
          const { res } = response;
          if (res.data.Status) {
            self.$router.push({
              path:
                "/paymentCheck?ref=" +
                paymentResponse.orderReference +
                "&rid=" +
                self.reserveID
            });
          } else if (res.data.Rebook) {
            self.makeTransactions(paymentResponse);
          } else {
            self.$toasted.show(res.data.Message, {
              position: "top-center",
              duration: 5000
            });
          }
        })
        .catch(error => {
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        });
    },
    CCOnKeyUp: function(item, type, e, card) {
      //for cvv
      if (type == "cvv") {
        if (card) {
          this.selectedCard = card;
        }

        if (this.creditCardDetails.cvv.length > 3) {
          this.creditCardDetails.cvv = this.creditCardDetails.cvv.slice(0, -1);
          this.$refs.cvv.blur();
        }
      }
      //for year and month
      if (type == "expiry") {
        if (
          this.creditCardDetails.expiryMonth.length == 2 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(
            0,
            -1
          );
          this.$refs.cvv.focus();
        }
        // if (this.creditCardDetails.expiryYear.length == 0 && item == 2) {
        //   this.$refs["expiry1"].focus();
        // }
      }
      // expiryYear
      if (type == "expiryYear") {
        if (
          this.creditCardDetails.expiryMonth.length == 2 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(
            0,
            -1
          );
          this.$refs.cvv.focus();
        }
      }
      //for number
      if (type == "number") {
        let temp = "item" + item;
        let focusVal = this.isfocus[temp];
        if (
          this.creditCardDetails.number[item].length == 0 &&
          item != 0 &&
          !focusVal
        ) {
          let value = "card" + (item - 1);
          this.$refs[value].focus();
        }
        if (this.creditCardDetails.number[item].length > 4) {
          this.creditCardDetails.number[item] = this.creditCardDetails.number[
            item
          ].slice(0, -1);
        }
        if (
          this.creditCardDetails.number[item].length == 4 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          if (item == 3) {
            this.$refs["cardName"].focus();
            return;
          }
          let value = "card" + (item + 1);
          this.$refs[value].focus();
        }
      }
    },
    onRemoveCard: function(card) {
      let token = TokenService.getToken();
      let payload = {
        CardID: card.cardID
      };
      makeRequest("/RemoveCard", "POST", token, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.$toasted.show(res.data.Message);
            //this.getPaymentOptions();
            this.getSavedCards();
            setTimeout(() => {
              this.$toasted.clear();
            }, 3000);
          } else {
            this.cardError = res.data.Message;
            this.$toasted.show(res.data.Message);
            setTimeout(() => {
              this.$toasted.clear();
            }, 3000);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/mobilePayment.vue